import { createGlobalStyle } from 'styled-components'
const GlobalStyles = createGlobalStyle`
  body {
    font-family: 'Poppins', sans-serif;
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.app.background};
    color: ${({ theme }) => theme.app.text};
    overflow: 'hidden'
  }
`

export default GlobalStyles
